export const SOURCE_TYPE_OPTIONS = [
  { value: 'file_to_text', label: 'Documento (file-to-text)' },
  { value: 'manual', label: 'Manual' },
  { value: 'url', label: 'URL' },
];

export const DEFAULT_ESCALATION_COOLDOWN_HOURS = '24';
export const DEFAULT_SESSION_CLOSE_POLICY = 'timeout';
export const DEFAULT_INTERACTIVE_LIST_BUTTON_LABEL = 'Ver opções';

export const SESSION_CLOSE_POLICY_OPTIONS = [
  { value: 'timeout', label: 'Por tempo de inatividade' },
  { value: 'per_interaction', label: 'Uma interação' },
];

export function buildEscalationCooldownConfiguration(value) {
  if (value == null || String(value).trim() === '') {
    return {};
  }
  const hours = Number(value);
  return Number.isInteger(hours) && hours >= 0
    ? { escalation_cooldown_hours: hours }
    : {};
}

export const SUB_AGENT_TYPE_OPTIONS = [
  { value: 'onboarding', label: 'Qualificação do contato' },
  { value: 'skills', label: 'Habilidade' },
  { value: 'guardrails', label: 'Regras de segurança' },
  { value: 'human_loop', label: 'Escalar para humano' },
];

export const SUB_AGENT_TYPE_CARD_OPTIONS = [
  {
    value: 'onboarding',
    label: 'Qualificação do contato',
    description:
      'Faz perguntas para conhecer o contato e reunir informações antes da conversa principal.',
  },
  {
    value: 'skills',
    label: 'Habilidade',
    description:
      'Busca conteúdo (RAG), executa ferramentas (MCP) ou chama APIs conforme as instruções.',
  },
  {
    value: 'guardrails',
    label: 'Segurança',
    description: 'Valida respostas contra regras de segurança.',
  },
  {
    value: 'human_loop',
    label: 'Humano',
    description: 'Transfere a conversa para um atendente humano.',
  },
];

export const SKILLS_EXECUTION_PHASE_OPTIONS = [
  { value: 'pre_response', label: 'Antes da resposta' },
  { value: 'post_response', label: 'Depois da resposta' },
];

export const FIXED_EXECUTION_PHASE_BY_TYPE = {
  onboarding: 'gate',
  guardrails: 'post_response',
  human_loop: 'post_response',
};

export const EXECUTION_PHASE_LABELS = {
  gate: 'Antes da conversa',
  pre_response: 'Antes da resposta',
  post_response: 'Depois da resposta',
};

export const BEHAVIOR_EXECUTION_SEQUENTIAL = 'sequential';
export const BEHAVIOR_EXECUTION_SELECTIVE = 'selective';

export function buildBehaviorExecutionConfiguration(selectiveEnabled) {
  return {
    behavior_execution: selectiveEnabled
      ? BEHAVIOR_EXECUTION_SELECTIVE
      : BEHAVIOR_EXECUTION_SEQUENTIAL,
  };
}

export function getExecutionPhase(subAgent) {
  if (subAgent.type === 'skills') {
    return subAgent.executionPhase === 'post_response' ? 'post_response' : 'pre_response';
  }

  return FIXED_EXECUTION_PHASE_BY_TYPE[subAgent.type];
}

/** Configurações que só existem no tipo indicado e se perdem ao trocar de tipo. */
export const TYPE_EXCLUSIVE_SETTING_LABELS = {
  onboarding: 'webhook de conclusão da qualificação',
  guardrails: 'ação em caso de falha',
  human_loop: 'mensagem de escalonamento',
};

export function buildSubAgentTypeChangeMessage(subAgent, newType) {
  const currentPhase = getExecutionPhase(subAgent);
  const nextPhase = getExecutionPhase({ ...subAgent, type: newType });

  const parts = [
    `Este comportamento deixa de ser «${getSubAgentTypeLabel(subAgent.type)}» e passa a ser ` +
      `«${getSubAgentTypeLabel(newType)}».`,
  ];

  if (currentPhase !== nextPhase) {
    parts.push(
      `Ele também muda de momento no fluxo: de «${EXECUTION_PHASE_LABELS[currentPhase]}» ` +
        `para «${EXECUTION_PHASE_LABELS[nextPhase]}».`
    );
  }

  const exclusiveSetting = TYPE_EXCLUSIVE_SETTING_LABELS[subAgent.type];
  if (exclusiveSetting) {
    parts.push(`A configuração exclusiva do tipo atual (${exclusiveSetting}) será descartada.`);
  }

  parts.push('A mudança passa a valer nas próximas mensagens depois de salvar o agente.');

  return parts.join(' ');
}

export const LLM_INHERIT_PROFILE_OPTION = { value: '', label: 'Herdar do agente' };

export const RELEVANCE_MODE_OPTIONS = [
  { value: '', label: 'Herdar do agente' },
  { value: 'high', label: 'Alta' },
  { value: 'strict', label: 'Restrita' },
  { value: 'medium', label: 'Média' },
  { value: 'low', label: 'Baixa' },
];

export const AGENT_RELEVANCE_MODE_OPTIONS = [
  { value: 'high', label: 'Alta (padrão)' },
  { value: 'strict', label: 'Restrita' },
  { value: 'medium', label: 'Média' },
  { value: 'low', label: 'Baixa' },
];

export const KNOWLEDGE_RESPONSE_MODE_OPTIONS = [
  { value: 'creative', label: 'Mais criativa' },
  { value: 'restricted', label: 'Mais restrita' },
];

export const KNOWLEDGE_MAX_EVIDENCES_OPTIONS = [
  { value: '1', label: '1 evidência' },
  { value: '2', label: '2 evidências (padrão)' },
  { value: '3', label: '3 evidências' },
  { value: '4', label: '4 evidências' },
  { value: '5', label: '5 evidências' },
  { value: '6', label: '6 evidências' },
  { value: '7', label: '7 evidências' },
  { value: '8', label: '8 evidências' },
  { value: '9', label: '9 evidências' },
  { value: '10', label: '10 evidências' },
];

export const KNOWLEDGE_MAX_EVIDENCES_UNLIMITED = '0';

export const KNOWLEDGE_RETRIEVAL_MODE_OPTIONS = [
  { value: 'focused', label: 'Focada (padrão)' },
  { value: 'diverse', label: 'Diversificada' },
];

export const GUARDRAIL_ACTION_OPTIONS = [
  { value: 'warn', label: 'Avisar' },
  { value: 'rewrite', label: 'Reescrever' },
  { value: 'block', label: 'Bloquear' },
];

export const DEFAULT_PROCESSING_FEEDBACK_MEDIA_MESSAGES = {
  image: 'Estou analisando sua imagem e já te retorno.',
  video: 'Estou analisando seu vídeo e já te retorno.',
  document: 'Estou analisando seu documento e já te retorno.',
  audio: 'Estou ouvindo seu áudio e já te retorno.',
  voice: 'Estou ouvindo seu áudio e já te retorno.',
  default: 'Estou processando seu arquivo e já te retorno.',
};

export const PROCESSING_FEEDBACK_MEDIA_FIELDS = [
  { key: 'image', label: 'Imagem' },
  { key: 'video', label: 'Vídeo' },
  { key: 'document', label: 'Documento' },
  { key: 'audio', label: 'Áudio' },
  { key: 'voice', label: 'Mensagem de voz' },
  { key: 'default', label: 'Padrão (outros arquivos)' },
];

export const DEFAULT_VISUAL_OUTPUT_FEEDBACK_MESSAGES = {
  pdf: 'Vou preparar seu PDF e já te envio.',
  png: 'Vou gerar sua imagem e já te envio.',
  jpg: 'Vou gerar sua imagem e já te envio.',
  default: 'Vou preparar seu arquivo visual e já te envio.',
};

export const VISUAL_OUTPUT_FEEDBACK_FIELDS = [
  { key: 'pdf', label: 'PDF' },
  { key: 'png', label: 'PNG' },
  { key: 'jpg', label: 'JPG' },
  { key: 'default', label: 'Padrão (outros formatos)' },
];

export function createDefaultProcessingFeedbackForm() {
  return {
    enabled: true,
    typingForText: true,
    mediaMessages: { ...DEFAULT_PROCESSING_FEEDBACK_MEDIA_MESSAGES },
    visualOutputEnabled: true,
    visualOutputFormatMessages: { ...DEFAULT_VISUAL_OUTPUT_FEEDBACK_MESSAGES },
  };
}

export function mapProcessingFeedbackToForm(configurations = {}) {
  const processingFeedback = configurations.processing_feedback || {};
  const visualOutput = processingFeedback.visual_output || {};

  return {
    enabled: processingFeedback.enabled !== false,
    typingForText: processingFeedback.typing_for_text !== false,
    mediaMessages: {
      ...DEFAULT_PROCESSING_FEEDBACK_MEDIA_MESSAGES,
      ...(processingFeedback.media_messages || {}),
    },
    visualOutputEnabled: visualOutput.enabled !== false,
    visualOutputFormatMessages: {
      ...DEFAULT_VISUAL_OUTPUT_FEEDBACK_MESSAGES,
      ...(visualOutput.format_messages || {}),
    },
  };
}

export function buildProcessingFeedbackConfiguration(processingFeedback) {
  const mediaMessages = {};

  Object.entries(processingFeedback.mediaMessages || {}).forEach(([key, value]) => {
    const trimmed = (value || '').trim();
    if (trimmed) {
      mediaMessages[key] = trimmed;
    }
  });

  const formatMessages = {};
  Object.entries(processingFeedback.visualOutputFormatMessages || {}).forEach(
    ([key, value]) => {
      const trimmed = (value || '').trim();
      if (trimmed) {
        formatMessages[key] = trimmed;
      }
    }
  );

  return {
    processing_feedback: {
      enabled: Boolean(processingFeedback.enabled),
      typing_for_text: Boolean(processingFeedback.typingForText),
      media_messages: mediaMessages,
      visual_output: {
        enabled: Boolean(processingFeedback.visualOutputEnabled),
        format_messages: formatMessages,
      },
    },
  };
}

export const MESSAGE_POLISH_MODE_OPTIONS = [
  { value: 'standard', label: 'Padrão — enxuga texto sem mudar o teor' },
  { value: 'light', label: 'Leve — remove fluff, não encurta receitas/passos' },
  { value: 'skip', label: 'Desativado — envia draft sem polish' },
];

export function buildMessagePolishConfiguration(messagePolishMode) {
  return { message_polish: { mode: messagePolishMode || 'standard' } };
}

export const RESPONSE_DEPTH_OPTIONS = [
  { value: 'chat', label: 'Chat — respostas curtas por padrão' },
  { value: 'expert', label: 'Expert — preserva análises, critérios e métricas' },
];

export function buildResponseDepthConfiguration(responseDepth) {
  return { response_depth: responseDepth === 'expert' ? 'expert' : 'chat' };
}

export const MESSAGE_FORMAT_OPTIONS = [
  { value: 'simple', label: 'Simples — texto sem marcação visual' },
  { value: 'rich', label: 'Rica — títulos, destaques e listas legíveis' },
];

export function buildMessageFormatConfiguration(messageFormat) {
  return { message_format: messageFormat === 'rich' ? 'rich' : 'simple' };
}

export const DEFAULT_LONG_ANALYSIS_ACKNOWLEDGEMENT =
  'Vou analisar seus dados com cuidado e já te retorno.';
export const DEFAULT_LONG_ANALYSIS_FAILURE_MESSAGE =
  'Não consegui concluir sua análise agora. Pode enviar novamente que eu tento outra vez.';

export function createDefaultLongRunningAnalysisForm() {
  return {
    enabled: false,
    acknowledgement: DEFAULT_LONG_ANALYSIS_ACKNOWLEDGEMENT,
    failureMessage: DEFAULT_LONG_ANALYSIS_FAILURE_MESSAGE,
  };
}

export function mapLongRunningAnalysisToForm(configurations = {}) {
  const config = configurations.long_running_analysis || {};
  return {
    enabled: config.enabled === true,
    acknowledgement:
      config.acknowledgement || DEFAULT_LONG_ANALYSIS_ACKNOWLEDGEMENT,
    failureMessage:
      config.failure_message || DEFAULT_LONG_ANALYSIS_FAILURE_MESSAGE,
  };
}

export function buildLongRunningAnalysisConfiguration(value) {
  return {
    long_running_analysis: {
      enabled: Boolean(value?.enabled),
      acknowledgement:
        value?.acknowledgement?.trim() || DEFAULT_LONG_ANALYSIS_ACKNOWLEDGEMENT,
      failure_message:
        value?.failureMessage?.trim() || DEFAULT_LONG_ANALYSIS_FAILURE_MESSAGE,
    },
  };
}

export const DEFAULT_SKILLS_INSTRUCTIONS =
  'Use a base de conhecimento para responder com precisão. Cite informações relevantes dos documentos indexados.';

export function createEmptySubAgent(defaultKnowledgeBaseId = null) {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    name: '',
    type: 'onboarding',
    enabled: true,
    instructions: '',
    executionPhase: 'pre_response',
    knowledgeBaseIds: defaultKnowledgeBaseId ? [defaultKnowledgeBaseId] : [],
    inheritLlmProfile: true,
    llmModelLineId: '',
    llmEffortId: '',
    knowledgeRelevanceMode: '',
    knowledgeResponseMode: 'creative',
    knowledgeRetrievalMode: 'focused',
    knowledgeMaxEvidences: '2',
    guardrailAction: 'warn',
    escalationMessage: '',
    priority: '0',
    mcpBindings: [],
    maxToolIterations: '',
    mcpFollowupReuseEnabled: false,
    mcpFollowupReuseTtlSeconds: '3600',
    postResponseActionOnly: false,
    completionWebhookEnabled: false,
    completionWebhookDelivery: 'direct',
    completionWebhookEdgeRef: '',
    completionWebhookUrl: '',
    completionWebhookMethod: 'POST',
    completionWebhookHeaders: '',
    mcpFieldPersistenceEnabled: false,
    mcpFieldPersistenceFields: '',
    consumeUpstreamSkillsEnabled: false,
    consumeUpstreamSkills: [],
  };
}

export function parseMcpFieldPersistenceFields(text) {
  return String(text || '')
    .split(/[\n,]/)
    .map((field) => field.trim())
    .filter((field, index, list) => field && list.indexOf(field) === index);
}

const SUB_AGENT_TYPE_LABELS = Object.fromEntries(
  SUB_AGENT_TYPE_OPTIONS.map((option) => [option.value, option.label])
);

export function getSubAgentTypeLabel(type) {
  return SUB_AGENT_TYPE_LABELS[type] || type;
}

function isAutoGeneratedSubAgentName(name, type) {
  if (!name || !type) {
    return false;
  }
  if (name === `${type}_principal`) {
    return true;
  }
  return new RegExp(`^${type}_\\d+$`).test(name);
}

export function getSubAgentDisplayLabel(subAgent, index) {
  const customName = subAgent.name?.trim();
  if (customName && !isAutoGeneratedSubAgentName(customName, subAgent.type)) {
    return customName;
  }

  const typeLabel = getSubAgentTypeLabel(subAgent.type);
  if (typeLabel) {
    return typeLabel;
  }

  return `Comportamento ${index + 1}`;
}

export function isSubAgentIncomplete(subAgent) {
  if (!subAgent.instructions?.trim()) {
    return true;
  }

  const incompleteMcpBinding = (subAgent.mcpBindings || []).some(
    (binding) => binding.mcpServerId && !binding.instructions?.trim()
  );
  if (incompleteMcpBinding) {
    return true;
  }

  return Boolean(getCompletionWebhookConfigError(subAgent));
}

/**
 * Parses optional webhook headers JSON.
 * Empty input → undefined. Invalid JSON / non-object → throws.
 */
export function parseCompletionWebhookHeaders(raw) {
  const headersRaw = (raw || '').trim();
  if (!headersRaw) {
    return undefined;
  }

  let parsed;
  try {
    parsed = JSON.parse(headersRaw);
  } catch {
    throw new Error(
      'Headers do webhook devem ser um JSON válido, por exemplo: {"Authorization":"Bearer seu-token"}'
    );
  }

  if (
    parsed === null ||
    typeof parsed !== 'object' ||
    Array.isArray(parsed)
  ) {
    throw new Error(
      'Headers do webhook devem ser um objeto JSON (não lista nem texto solto).'
    );
  }

  return parsed;
}

/** Returns a user-facing validation error for onboarding webhook fields, or null. */
export function getCompletionWebhookConfigError(subAgent) {
  if (subAgent?.type !== 'onboarding' || !subAgent.completionWebhookEnabled) {
    return null;
  }

  const delivery = subAgent.completionWebhookDelivery || 'direct';
  if (delivery === 'edge') {
    const endpointRef = (subAgent.completionWebhookEdgeRef || '').trim();
    if (!/^webhook:[a-z0-9][a-z0-9._-]*$/.test(endpointRef)) {
      return 'Informe uma referência Edge válida, por exemplo webhook:cria-ticket.';
    }
    return null;
  }

  const url = (subAgent.completionWebhookUrl || '').trim();
  if (!url) {
    return 'Informe a URL do webhook de conclusão da qualificação.';
  }
  try {
    parseCompletionWebhookHeaders(subAgent.completionWebhookHeaders);
  } catch (err) {
    return err.message || 'Headers do webhook inválidos.';
  }

  return null;
}

export function buildSubAgentName(type, subAgents, currentIndex) {
  const sameTypeCount = subAgents
    .slice(0, currentIndex)
    .filter((item) => item.type === type).length;
  return sameTypeCount === 0 ? `${type}_principal` : `${type}_${sameTypeCount + 1}`;
}

export function buildSubAgentConfigurations(subAgent) {
  const configurations = {};

  if (subAgent.knowledgeBaseIds?.length && subAgent.knowledgeRelevanceMode) {
    configurations.knowledge_relevance_mode = subAgent.knowledgeRelevanceMode;
  }

  if (subAgent.knowledgeBaseIds?.length) {
    configurations.knowledge_response_mode = subAgent.knowledgeResponseMode || 'creative';
    configurations.knowledge_retrieval_mode =
      subAgent.knowledgeRetrievalMode || 'focused';
  }

  if (subAgent.knowledgeBaseIds?.length && subAgent.knowledgeRetrievalMode === 'diverse') {
    configurations.knowledge_max_evidences = 0;
  } else if (subAgent.knowledgeBaseIds?.length && subAgent.knowledgeMaxEvidences) {
    const maxEvidences = parseInt(subAgent.knowledgeMaxEvidences, 10);
    if (!Number.isNaN(maxEvidences) && maxEvidences >= 1) {
      configurations.knowledge_max_evidences = maxEvidences;
    }
  }

  if (subAgent.type === 'guardrails' && subAgent.guardrailAction) {
    configurations.action = subAgent.guardrailAction;
  }

  if (subAgent.type === 'human_loop' && subAgent.escalationMessage?.trim()) {
    configurations.escalation_message = subAgent.escalationMessage.trim();
  }

  if (subAgent.mcpBindings?.length) {
    configurations.mcp_bindings = subAgent.mcpBindings
      .filter((binding) => binding.mcpServerId && binding.instructions?.trim())
      .map((binding) => ({
        mcp_server_id: binding.mcpServerId,
        instructions: binding.instructions.trim(),
        contact_scoped: Boolean(binding.contactScoped),
      }));

    if (subAgent.maxToolIterations !== undefined && subAgent.maxToolIterations !== '') {
      const parsedIterations = parseInt(subAgent.maxToolIterations, 10);
      if (!Number.isNaN(parsedIterations) && parsedIterations >= 1) {
        configurations.max_tool_iterations = parsedIterations;
      }
    }
  }

  if (subAgent.type === 'skills' && subAgent.mcpFollowupReuseEnabled) {
    const ttl = parseInt(subAgent.mcpFollowupReuseTtlSeconds, 10);
    configurations.mcp_followup_reuse = {
      enabled: true,
      ttl_seconds: Number.isNaN(ttl) ? 3600 : ttl,
    };
  }

  if (subAgent.type === 'skills' && subAgent.postResponseActionOnly) {
    configurations.post_response_action_only = true;
  }

  if (subAgent.type === 'skills' && subAgent.consumeUpstreamSkillsEnabled) {
    configurations.consume_upstream_skills = {
      enabled: true,
      skills: Array.isArray(subAgent.consumeUpstreamSkills)
        ? subAgent.consumeUpstreamSkills
        : [],
    };
  }

  if (subAgent.type === 'onboarding' && subAgent.completionWebhookEnabled) {
    const delivery = subAgent.completionWebhookDelivery || 'direct';
    if (delivery === 'edge') {
      const endpointRef = (subAgent.completionWebhookEdgeRef || '').trim();
      if (endpointRef) {
        configurations.completion_webhook = {
          edge_endpoint_ref: endpointRef,
          method: 'POST',
        };
      }
    } else {
      const url = (subAgent.completionWebhookUrl || '').trim();
      if (url) {
        const webhook = {
          url,
          method: subAgent.completionWebhookMethod || 'POST',
        };
        const headers = parseCompletionWebhookHeaders(subAgent.completionWebhookHeaders);
        if (headers) {
          webhook.headers = headers;
        }
        configurations.completion_webhook = webhook;
      }
    }
  }

  if (subAgent.type === 'onboarding' && subAgent.mcpFieldPersistenceEnabled) {
    const fields = parseMcpFieldPersistenceFields(subAgent.mcpFieldPersistenceFields);
    configurations.mcp_field_persistence = fields.length
      ? { enabled: true, fields }
      : { enabled: true };
  }

  return configurations;
}

export function buildSubAgentPayload(subAgent, index, subAgents) {
  const payload = {
    type: subAgent.type,
    name: subAgent.name?.trim() || buildSubAgentName(subAgent.type, subAgents, index),
    enabled: subAgent.enabled !== false,
    instructions: subAgent.instructions,
    configurations: buildSubAgentConfigurations(subAgent),
  };

  payload.execution_phase = getExecutionPhase(subAgent);

  if (subAgent.inheritLlmProfile) {
    payload.inherit_llm_profile = true;
  } else {
    if (subAgent.llmModelLineId) {
      payload.llm_model_line_id = subAgent.llmModelLineId;
    }
    if (subAgent.llmEffortId) {
      payload.llm_effort_id = subAgent.llmEffortId;
    }
  }

  const priority = parseInt(subAgent.priority, 10);
  if (!Number.isNaN(priority)) {
    payload.priority = priority;
  }

  if (subAgent.knowledgeBaseIds?.length) {
    payload.knowledge_base_ids = subAgent.knowledgeBaseIds;
  }

  return payload;
}
